import { render, staticRenderFns } from "./SoldOutItems.vue?vue&type=template&id=1b78c369&"
import script from "./SoldOutItems.vue?vue&type=script&lang=js&"
export * from "./SoldOutItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports